// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiObtainPriorAuthorization {
    static getAttributeTypeMap() {
        return MedicalBiObtainPriorAuthorization.attributeTypeMap;
    }
}
MedicalBiObtainPriorAuthorization.discriminator = undefined;
MedicalBiObtainPriorAuthorization.additionalProperties = false;
MedicalBiObtainPriorAuthorization.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "org",
        "baseName": "org",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "requirements",
        "baseName": "requirements",
        "type": "string"
    },
    {
        "name": "website",
        "baseName": "website",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiObtainPriorAuthorization.js.map